import { handleResponse } from '../../Helpers/handle-response';

import * as apiHelper from '../../Helpers/apiHelper';

export function getPalletDataBySSCC(sscc, workstationId, userId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPALLETDATABYSSCC);
    url += `?sscc=${sscc}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=${userId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getPrintPreviewBySSCC(sscc, workstationId, userId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLABELPREVIEWBYSSCC);
    url += `?sscc=${sscc}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=${userId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function printLabel(printerLocationId, workstationId, oldSscc, newSscc, orderId, userId, productId, printReasonId, printReasonDescription, printsQuantity) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRINTLABEL);
    url += `?printerLocationId=${printerLocationId}`;
    url += `&workstationId=${workstationId}`;
    url += `&oldSscc=${oldSscc}`;
    url += `&newSscc=${newSscc}`;
    url += `&orderId=${orderId}`;
    url += `&userId=${userId}`;
    url += `&productId=${productId}`;
    url += `&printReasonId=${printReasonId}`;
    url += `&printReasonDescription=${printReasonDescription}`;
    url += `&printsQuantity=${printsQuantity}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getNewPalletNumber(orderReference, workstationId, userId, quantity) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETNEWPALLETNUMBER);
    url += `?orderReference=${orderReference}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=${userId}`;
    url += `&quantity=${quantity}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}




